module.exports = (data) => {
  const containerItemSeparator = '|';
  const params = {};

  switch (data.pageType) {
    default:
      params.method = 'track';
      params.type = data.pageType;
      break;

    case 'category':
      params.method = data.pageType;
      params.categoryId = data.id;
      params.categoryName = data.name;
      params.productIds = data.itemIds.join(containerItemSeparator);
      if (data.itemIds && data.itemIds.length) {
        params.productIds = data.itemIds.join(containerItemSeparator);
      }
      params.productSeparator = containerItemSeparator;
      break;

    case 'product':
      params.method = data.pageType;
      params.productId = data.id;
      params.productName = data.name;
      params.categoryId = data.categoryId;
      if (data.relatedItemIds && data.relatedItemIds.length) {
        params.productIds = data.relatedItemIds.join(containerItemSeparator);
      }
      params.productSeparator = containerItemSeparator;
      break;

    case 'search':
      params.method = data.pageType;
      params.search = data.q;
      params.productIds = data.itemIds.join(containerItemSeparator);
      params.productSeparator = containerItemSeparator;
      break;
  }

  return params;
};



// WEBPACK FOOTER //
// ./src/_utilities/create-adcell-query-params.js